import React, { FC, useState } from 'react'
import { t } from '@lingui/macro'
import { ItemList } from '../../../components/common/list/ItemList'
import {
  TargetUserIds,
  useManageUsersPageContext
} from '../ManageUsersPageContext'
import IUser from '../types/IUser'
import { AddGroupModal } from './AddUserToGroupModal'
import { UsersBatchActions } from './UsersBatchActions'
import { Filters } from './Filters'
import { Item } from './Item'
import { useAllGroupsQuery } from 'front-end/src/graphql/commonQueries/allGroups.codegen'
import { UsersExportToCsvDocument } from './UsersList.codegen'
import { DownloadCSVButton } from '../../../components/common/download-csv-button/DownloadCSVButton'
import { HStack } from 'front-end/src/components'
import { prepareUserListExportCSV } from './csv-user-list'
import { PAGE_SIZE } from 'front-end/src/pages/manage-users-page/ManageUsersPageContainer'

export interface IListState {
  addGroupModalTarget: TargetUserIds | null
}

export const UsersList: FC = () => {
  const [addGroupModalTarget, setAddGroupModalTarget] = useState<number | null>(
    null
  )

  const {
    users,
    usersCount,
    onPageChange,
    filterAsDescriptors,
    onAddToGroup,
    loading,
    page
  } = useManageUsersPageContext()

  const { data } = useAllGroupsQuery({
    fetchPolicy: 'cache-first'
  })
  const hideAddGroupModal = () => setAddGroupModalTarget(null)

  return (
    <>
      <ItemList
        loading={loading}
        items={users}
        itemsCount={usersCount}
        renderItem={(user: IUser) => (
          <Item
            // @ts-expect-error 9/11/2020
            user={user}
            toggleAddGroupModal={(value) => {
              if (addGroupModalTarget === user.id && !value) {
                hideAddGroupModal()
              }

              if (value) {
                setAddGroupModalTarget(user.id)
              }
            }}
          />
        )}
        page={page}
        pageSize={PAGE_SIZE}
        onPageChange={onPageChange}
        header={
          <HStack
            align="stretch"
            flexGrow={1}
            spacing="8px"
            bg="white"
            p="16px"
          >
            <UsersBatchActions />
            <Filters />
          </HStack>
        }
        actions={
          <DownloadCSVButton
            count={usersCount}
            fileName={'users'}
            dataPath={'data.admin.organisation.users'}
            queryOptions={(page, limit) => ({
              variables: {
                filters: filterAsDescriptors(true),
                offset: (page - 1) * limit,
                limit
              },
              query: UsersExportToCsvDocument,
              fetchPolicy: 'no-cache'
            })}
            prepareData={prepareUserListExportCSV}
          />
        }
        emptyState={t`No people found`}
      />
      <AddGroupModal
        excludeExistingGroups
        target={addGroupModalTarget || []}
        show={!!addGroupModalTarget}
        key={addGroupModalTarget}
        onHide={hideAddGroupModal}
        groups={data?.groups}
        onAddToGroup={onAddToGroup}
        users={users}
      />
    </>
  )
}
